export enum Breakpoints {
  SMALL,
  MEDIUM,
  LARGE,
  XLARGE,
}
